/* eslint-disable consistent-return */
/* eslint-disable react/no-unstable-nested-components */
import { CalendarOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  DatePicker,
  Divider,
  Select,
  Space,
  Table, TableColumnsType, Typography
} from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';

import NationwideByAccum from './NationwideByAccum';
import NationwideByMonth from './NationwideByMonth';

import { useAppSelector } from 'app/store';
import { sampleTypeTable } from 'common/assets/dummyData/system';
import Icon from 'common/components/Icon';
import { exportKioskGroupReportV3Service, getKioskGroupReportV3Service } from 'common/services/dashboard';
import { KioskGroupReport, KioskGroupReportType, KioskGroupReportTypeTrans } from 'common/services/dashboard/types';
import { defaultDateRangeYear, formatDateYYYYMMDD, formatNumberWithSeparators } from 'common/utils/functions';
import roles, { getPermission } from 'configs/roles';
import HeaderKiosk from 'extends/HeaderKiosk';
import KioskDashboardFilter from 'extends/KioskDashboardFilter';

// interface DataType {
//   order: number;
//   name: string;
//   installTime: string;
//   ratingTime: string;
//   average: string;
//   heartRisk: string;
//   cardioIll: string;
//   kisokType: string;
// }

const PAGE_SIZE = 6;

// const testData = [
//   {
//     order: 1,
//     name: 'Bệnh viện Bạch Mai',
//     installTime: '2023-01-01',
//     ratingTime: '2023-01-01',
//     average: '100',
//     heartRisk: '100',
//     cardioIll: '100',
//     kisokType: 'QR Code',
//   },
//   {
//     order: 2,
//     name: 'Bệnh viện Nam khoa',
//     installTime: '2023-01-01',
//     ratingTime: '2023-01-01',
//     average: '100',
//     heartRisk: '100',
//     cardioIll: '100',
//     kisokType: 'Kiosk',
//   },
//   {
//     order: 3,
//     name: 'Bệnh viện Chợ Rẫy',
//     installTime: '2023-01-01',
//     ratingTime: '2023-01-01',
//     average: '100',
//     heartRisk: '100',
//     cardioIll: '100',
//     kisokType: 'HIS',
//   },
//   {
//     order: 4,
//     name: 'Bệnh viện Chợ Rẫy',
//     installTime: '2023-01-01',
//     ratingTime: '2023-01-01',
//     average: '100',
//     heartRisk: '100',
//     cardioIll: '100',
//     kisokType: 'HIS',
//   },
//   {
//     order: 5,
//     name: 'Bệnh viện Chợ Rẫy',
//     installTime: '2023-01-01',
//     ratingTime: '2023-01-01',
//     average: '100',
//     heartRisk: '100',
//     cardioIll: '100',
//     kisokType: 'HIS',
//   },
//   {
//     order: 6,
//     name: 'Bệnh viện Chợ Rẫy',
//     installTime: '2023-01-01',
//     ratingTime: '2023-01-01',
//     average: '100',
//     heartRisk: '100',
//     cardioIll: '100',
//     kisokType: 'HIS',
//   },
//   {
//     order: 7,
//     name: 'Bệnh viện Chợ Rẫy',
//     installTime: '2023-01-01',
//     ratingTime: '2023-01-01',
//     average: '100',
//     heartRisk: '100',
//     cardioIll: '100',
//     kisokType: 'HIS',
//   }
// ];

const RatingCounter: React.FC = () => {
  const rolesUser = useAppSelector((state) => state.auth.roles);
  const { t } = useTranslation();
  const [typeParam, setTypeParam] = useState<number | undefined>(undefined);
  const [kiosGroupId, setKiosGroupId] = React.useState<number[]>([]);
  const [dateRange, setDateRange] = React.useState<string[]>(defaultDateRangeYear);
  const [dateRangeTable, setDateRangeTable] = React.useState<string[]>([]);
  const [refetchFunc, setRefetchFunc] = useState<(() => void) | null>(null);
  const [refetchFunc2, setRefetchFunc2] = useState<(() => void) | null>(null);
  const [refetchFunc3, setRefetchFunc3] = useState<(() => void) | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentView, setCurrentView] = useState<number>(PAGE_SIZE);

  const { isLoading, data: kioskGroupReports, refetch } = useQuery(
    ['getAllKioskGroupReport', currentPage, currentView],
    () => getKioskGroupReportV3Service({
      page: currentPage,
      limit: currentView,
      from: dateRange[0],
      to: dateRange[1],
      ...(typeParam && { type: typeParam }),
      ...(kiosGroupId.join(',') && { kioskGroupIds: kiosGroupId.join(',') }),
      ...(dateRangeTable[0] && { 'setupAt[gte][0]': dateRangeTable[0] }),
      ...(dateRangeTable[1] && { 'setupAt[lte][0]': dateRangeTable[1] }),
    }),
    {
      enabled: !!currentPage,
    }
  );

  const { mutate: exportMutate, isLoading: exportLoading } = useMutation(
    ['exportKioskGroupReportV3Service'],
    () => exportKioskGroupReportV3Service({
      from: dateRange[0],
      to: dateRange[1],
      ...(typeParam && { type: typeParam }),
      ...(kiosGroupId.join(',') && { kioskGroupIds: kiosGroupId.join(',') }),
    }),
    {
      onSuccess(res) {
        if (res.link) {
          window.open(res.link, '_blank');
        }
      },
    }
  );

  const columns: TableColumnsType<KioskGroupReport> = [
    {
      title: t('dashboard2025.hospitalName'),
      dataIndex: 'name',
      filterDropdown: ({ setSelectedKeys, confirm, selectedKeys }) => (
        <div style={{ padding: 8, width: 300 }}>
          <Select
            mode="multiple"
            style={{ width: '100%' }}
            placeholder="Select names"
            value={selectedKeys}
            allowClear
            onChange={(values) => setSelectedKeys(values)}
            options={kioskGroupReports?.data.map((item) => ({
              label: item.name,
              value: item.name,
            }))}
          />
          <Space style={{ width: '100%', display: 'block' }}>
            <Button
              type="primary"
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size="middle"
              style={{ marginTop: 8, width: '100%' }}
            >
              {t('media.search')}
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
      ),
      onFilter: (value, record) => record.name.includes(value as any),
    },
    {
      title: t('dashboard2025.installTime'),
      dataIndex: 'setupAt',
      filterDropdown: () => (
        <div style={{ padding: 8, width: 300 }}>
          <DatePicker.RangePicker
            value={dateRangeTable.length
              ? [moment(dateRangeTable[0]), moment(dateRangeTable[1])] : undefined}
            size="large"
            style={{ width: '100%' }}
            placeholder={[t('dashboard.startDatePlaceholder'), t('dashboard.endDatePlaceholder')]}
            separator={<Divider style={{ margin: 0, width: 30, borderTop: '1px solid #8A94A6' }} />}
            onChange={(val) => {
              if (!val) {
                setDateRangeTable([]);
                return;
              }
              const res = val.map((item) => (formatDateYYYYMMDD(item)));
              setDateRangeTable(res);
            }}
          />
          <Space style={{ width: '100%', display: 'block' }}>
            <Button
              type="primary"
              onClick={() => refetch()}
              icon={<SearchOutlined />}
              size="middle"
              style={{ marginTop: 8, width: '100%' }}
            >
              {t('media.search')}
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <CalendarOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
      ),
    },
    {
      title: t('dashboard2025.ratingTime'),
      dataIndex: 'cumulative',
      sorter: (a, b) => a.cumulative - b.cumulative,
    },
    {
      title: t('dashboard2025.average'),
      dataIndex: 'avgMonthly',
      sorter: (a, b) => a.avgMonthly - b.avgMonthly,
    },
    {
      title: `% ${t('dashboard2025.heartRisk')}`,
      dataIndex: 'heartRiskHighAndVeryHigh',
      render: (heartRisk: number) => `${heartRisk}%`,
      sorter: (a, b) => a.heartRiskHighAndVeryHigh - b.heartRiskHighAndVeryHigh,
    },
    {
      title: `% ${t('dashboard2025.heart')}`,
      dataIndex: 'heartRisk',
      render: (heartRisk: number) => `${heartRisk}%`,
      sorter: (a, b) => a.heartRisk - b.heartRisk,
    },
    {
      title: t('dashboard2025.kioskType'),
      dataIndex: 'type',
      render: (type: KioskGroupReportType[]) => type.map((it) => KioskGroupReportTypeTrans[it]).join(', '),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
        <div style={{ padding: 8, width: 300 }}>
          <Select
            mode="multiple"
            style={{ width: '100%' }}
            placeholder="Select types"
            value={selectedKeys}
            allowClear
            onChange={(values) => setSelectedKeys(values)}
            options={sampleTypeTable.map((item) => ({
              value: item.value,
              label: item.label,
            }))}
          />
          <Space style={{ width: '100%', display: 'block' }}>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              size="middle"
              style={{ marginTop: 8, width: '100%' }}
              onClick={() => confirm()}
            >
              {t('media.search')}
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
      ),
      onFilter: (value, record) => record.type.includes(value as any),
    }
  ];

  const handleClear = () => {
    setDateRange([]);
    setTypeParam(undefined);
    setKiosGroupId([]);
  };

  return (
    <div className="ratingCounter">
      <HeaderKiosk
        icon={<Icon iconName="lineup2" />}
        title={t('dashboard2025.rating')}
      />
      <div className="ratingCounter-wrapper">
        <div className="ratingCounter-filter">
          <KioskDashboardFilter
            typeParam={typeParam}
            setTypeParam={setTypeParam}
            kiosGroupId={kiosGroupId}
            setKiosGroupId={setKiosGroupId}
            dateRange={dateRange}
            setDateRange={setDateRange}
            onClear={handleClear}
            onRefetch={() => refetchFunc?.()}
            onRefetch2={() => refetchFunc2?.()}
            onRefetch3={() => refetchFunc3?.()}
            onRefetch4={() => refetch()}
          />
        </div>
        <div className="ratingCounter-content">
          {getPermission(rolesUser, roles.REPORT_COUNTER_BY_MONTH) && (
            <NationwideByMonth
              dateRange={dateRange}
              typeParam={typeParam}
              kiosGroupId={kiosGroupId}
              setRefetchFunc={setRefetchFunc}
              setRefetchFunc2={setRefetchFunc3}
            />
          )}
          {getPermission(rolesUser, roles.REPORT_COUNTER_CUMULATIVE_BY_MONTH) && (
            <NationwideByAccum
              dateRange={dateRange}
              typeParam={typeParam}
              kiosGroupId={kiosGroupId}
              setRefetchFunc={setRefetchFunc2}
            />
          )}
        </div>
        {getPermission(rolesUser, roles.REPORT_KIOSK_GROUP_REPORT) && (
          <div className="ratingCounter-table">
            <Card
              title={(
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '4px 0 4px 0',
                  }}
                >
                  <Typography.Title level={4}>{t('dashboard.hospitalList')}</Typography.Title>
                  <Button
                    type="primary"
                    size="large"
                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                    onClick={() => exportMutate()}
                    disabled={exportLoading
                      || !getPermission(rolesUser, roles.EXPORT_KIOSK_GROUP_CUMULATIVE)}
                  >
                    {t('dashboard2025.excelExport')}
                    <Icon iconName="download" />
                  </Button>
                </div>
              )}
            >
              <Table
                loading={isLoading}
                columns={columns}
                rowKey="id"
                dataSource={kioskGroupReports?.data || []}
                pagination={{
                  pageSize: currentView,
                  total: kioskGroupReports?.meta.total || 0,
                  showSizeChanger: true,
                  pageSizeOptions: [6, 10, 20, 50, 100],
                  onChange(page, pageSize) {
                    setCurrentPage(page);
                    setCurrentView(pageSize);
                  },
                  onShowSizeChange(_, size) {
                    setCurrentPage(1);
                    setCurrentView(size);
                  },
                  showTotal: () => (
                    <div className="custom-total">
                      <span className="custom-total-text">{t('dashboard2025.show')}</span>
                      {' '}
                      <span className="custom-total-text-value">{currentView}</span>
                      {' '}
                      <span className="custom-total-text">{t('dashboard2025.linePerPage')}</span>
                    </div>
                  ),
                }}
                summary={(pageData) => {
                  let totalAvgMonthly = 0;
                  let totalCumulative = 0;

                  pageData.forEach(({ avgMonthly, cumulative }) => {
                    totalAvgMonthly += avgMonthly || 0;
                    totalCumulative += cumulative || 0;
                  });

                  return (
                    <Table.Summary.Row
                      style={{
                        backgroundColor: '#fafafa',
                        fontWeight: 'bold',
                      }}
                    >
                      <Table.Summary.Cell index={0}>{t('dashboard.totalLine')}</Table.Summary.Cell>
                      <Table.Summary.Cell index={1} />
                      <Table.Summary.Cell index={2}>{formatNumberWithSeparators(totalCumulative) || ''}</Table.Summary.Cell>
                      <Table.Summary.Cell index={3}>{formatNumberWithSeparators(totalAvgMonthly) || ''}</Table.Summary.Cell>
                      <Table.Summary.Cell index={4} />
                      <Table.Summary.Cell index={5} />
                      <Table.Summary.Cell index={6} />
                    </Table.Summary.Row>
                  );
                }}
              />
            </Card>
          </div>
        )}
      </div>
    </div>
  );
};

export default RatingCounter;
